// src/apiFetch.js
// Helper de fetch autenticado para o frontend — usa cookie HttpOnly de sessão

const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== 'undefined' && window.API_BASE_URL) ||
  'http://localhost:3007';

/**
 * Fetch autenticado — envia cookie HttpOnly com credentials: include.
 *
 * @param {string} path     - Caminho da rota (ex: '/api/locutor/falar')
 * @param {object} options  - Opções do fetch (method, body, headers, etc.)
 * @returns {Promise<Response>}
 *
 * @example
 * const res = await apiFetch('/api/locutor/falar', {
 *   method: 'POST',
 *   body: JSON.stringify({ texto: 'Olá!' })
 * });
 * const data = await res.json();
 */
function getClienteId() {
  try {
    return JSON.parse(localStorage.getItem('radio-ai-user') || '{}').id || '';
  } catch {
    return '';
  }
}

export async function apiFetch(path, options = {}) {
  const url = path.startsWith('http') ? path : `${API_BASE}${path}`;

  const clienteId = getClienteId();
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers = {
    ...(!isFormData ? { 'Content-Type': 'application/json' } : {}),
    ...(clienteId ? { 'x-cliente-id': clienteId } : {}),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    credentials: options.credentials || 'include',
    headers,
  });

  return response;
}

/**
 * apiFetch com JSON automático — parseia a resposta e lança erro em falha.
 *
 * @param {string} path
 * @param {object} options
 * @returns {Promise<any>} - Dados JSON da resposta
 * @throws {Error} - Com status e mensagem do servidor
 */
export async function apiFetchJSON(path, options = {}) {
  const response = await apiFetch(path, options);

  if (!response.ok) {
    let message = `Erro ${response.status}`;
    try {
      const data = await response.json();
      message = data.error || data.message || message;
    } catch {}
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }

  return response.json();
}

export { API_BASE };
